import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { RicosContext } from './../../../ricos-context';
import type { IToolbarItem } from './../../../ricos-types';
import { DropdownButton, ToggleButton } from './../../../toolbars-ui';

import { BORDER_TYPES, CATEGORY } from '../../consts';
import { BorderIcon } from '../../icons';
import { useColorPickerModal } from '../../modals/use-color-picker-modal';
import type { BordersType } from '../../types';
import { useBorderPanel } from '../modals/use-border-panel';

interface Props {
  toolbarItem: IToolbarItem;
  dataHook?: string;
}

export const BorderButton: FC<Props> = ({ dataHook, toolbarItem }) => {
  const { t } = useContext(RicosContext);
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);
  const isMultipleSelection = !(toolbarItem.attributes?.selectedCategory === CATEGORY.CELL_BORDER);

  const colorPickerModal = useColorPickerModal();

  const borderPanel = useBorderPanel({
    onClick: (borderType: BordersType) => {
      toggleColorPickerModal(borderType);
    },
    getSelectedStyle: () => '',
  });

  const toggleColorPickerModal = (borderType: BordersType) => {
    colorPickerModal.toggleModal(referenceElement, {
      color: toolbarItem.attributes?.cellBorderColor,
      onChange: color => toolbarItem.commands?.click({ type: borderType, color }),
    });
  };

  return !isMultipleSelection ? (
    <ToggleButton
      setRef={setReferenceElement}
      Icon={BorderIcon}
      onClick={() => {
        toggleColorPickerModal(BORDER_TYPES.borders);
      }}
      dataHook={dataHook}
      tooltip={t('TablePlugin_Toolbar_Border_Color')}
    />
  ) : (
    <DropdownButton
      dataHook={dataHook}
      active={borderPanel.isModalOpen}
      onClick={() => borderPanel.toggleModal(referenceElement)}
      setRef={setReferenceElement}
      Icon={BorderIcon}
      tooltip={t('TablePlugin_Toolbar_Border_Color')}
    />
  );
};
